module.exports = __webpack_public_path__ + "img/9exp.12aa6fa7.jpg";